import { BookingFor } from '~/types/booking'
import { OrderPayload, TutorForSelfOrderItem } from '~/types/order'
import { OrderPayloadAdapter, StripExtraKeys } from '~/booking/types'
import { TutorForSelfBookingFields } from '~/types/cart'
import { createBookingPreferenceFromCartItem } from '~/booking/utils/createBookingPreferenceFromCartItem'

type ParsedItem = StripExtraKeys<TutorForSelfBookingFields, TutorForSelfOrderItem>

export default class TutorForSelfOrderPayloadAdapter implements OrderPayloadAdapter {
  public readonly cartItems: TutorForSelfBookingFields
  private readonly campaignId: number | undefined

  public constructor(cartItems: TutorForSelfBookingFields, campaignId?: number) {
    this.cartItems = cartItems
    this.campaignId = campaignId
  }

  public createOrderPayload(): OrderPayload {
    return {
      campaignId: this.campaignId,
      bookingFor: BookingFor.SELF,
      items: [this._parseItem(this.cartItems)],
    }
  }

  private _parseItem(item: TutorForSelfBookingFields): ParsedItem {
    return createBookingPreferenceFromCartItem(item)
  }
}
